import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/templates/:id/connection(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TemplateContainer',
      './modules/template'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Template = require('./containers/TemplateContainer').default
      const actions = require('./modules/template')
      const reducer = require('./modules/template').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'practiceTemplateEdit', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, Template)

    /* Webpack named bundle   */
    }, 'practiceTemplateEdit')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/Template/index.js